import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { HttpEventType, HttpEvent } from "@angular/common/http";
import { ApiClientService } from "@shared/_services/api-client.service";
import { ToastrService } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { PreloaderComponent } from '@app/modules/utils/preloader/preloader.component';


@Component({
  selector: 'app-manage-region',
  standalone: true,
  imports: [CommonModule, FormsModule, PreloaderComponent],
  providers: [
    ToastrService,
  ],
  templateUrl: './manage-region.component.html',
  styleUrl: './manage-region.component.css'
})
export class ManageRegionComponent {
  loading: boolean = false;
  @Input() manageRegionData: any = {};
  @Output() categoryResponseEvent = new EventEmitter<string>();
  public regionModel: any = {};
  public hasError: boolean = false;
  public errorMsg: string = '';

  constructor(private _apiClientService: ApiClientService, private _toastrService: ToastrService) { }

  ngOnInit() {
    this.regionModel = this.manageRegionData.data || {};
  }

  onSubmit() {
    if (this.manageRegionData.action == 'add') {
      this.addRegion(this.regionModel);
    } else if (this.manageRegionData.action == 'edit') {
      this.updateRegion(this.regionModel);
    }
  }

  public async addRegion(region: any) {
    this.loading = true;
    (await this._apiClientService.addApiService('admin/select-option/region/create', region)).subscribe(
      (event: HttpEvent<any>): any => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.loading = true;
            break;
          case HttpEventType.Response:
            this.loading = false;
            let { status, error, message, data } = event.body;
            this._toastrService.success('Success', 'Added Region Successfully');
            //if (status == 200) {
              this.triggerRegionResponse('completed');
          // } else {
          //   this.hasError = true;
          //   this.errorMsg = 'something went wrong please contact Technical Support';
          // }
        }
      },
      (errorObj: any) => {
        this.loading = false;
        const errorMsg = errorObj?.error?.Message;
        this.hasError = true;
        this.errorMsg = errorMsg || 'something went wrong please contact Technical Support';
      }
    );
  }

  public async updateRegion(region: any) {
    this.loading = true;
    (await this._apiClientService.addApiService(`admin/select-option/region/${region.id}`, region)).subscribe(
      (event: HttpEvent<any>): any => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.loading = true;
            break;
          case HttpEventType.Response:
            this.loading = false;
            this._toastrService.success('Success', 'Updated Region Successfully');
            //let { status, error, message, data } = event.body;
            //if (status == 200) {
            this.triggerRegionResponse('completed');
          // } else {
          //   this.hasError = true;
          //   this.errorMsg = 'something went wrong please contact Technical Support';
          // }
        }
      },
      (errorObj: any) => {
        this.loading = false;
        const errorMsg = errorObj?.error?.Message;
        this.hasError = true;
        this.errorMsg = errorMsg || 'something went wrong please contact Technical Support';
      }
    );
  }

  public triggerRegionResponse(action: string) {
    this.categoryResponseEvent.emit(action);
  }

}
